import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SingleTowerLog } from "../../../../types/redux";
import { RootState } from "../../../store";
import { getSingleTowerlogAsync } from "./networkAPI";
import { useSelector } from "react-redux";

// Define state structure
interface SingleTowerLogState {
  SingleTowerLog: SingleTowerLog | null;
  loading: boolean;
  error: string | null;
}

// Initial state
const initialState: SingleTowerLogState = {
  SingleTowerLog: null,
  loading: false,
  error: null,
};

// Create slice
const singleTowerLogSlice = createSlice({
  name: "SingleTowerLog",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSingleTowerlogAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSingleTowerlogAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.SingleTowerLog = action.payload;
      })
      .addCase(getSingleTowerlogAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "An error occurred"; // Save error message
        console.log("Error fetching SingleTowerLog:", state.error);
      });
  },
});

export default singleTowerLogSlice;
